<template>
  <div
    class="admin-dir"
  >
    <h1>{{ id }}</h1>
    <a-space direction="vertical" style="width: 100%" v-if="writable">
      <a-row>
        <a-col :span="4">Create subdirectory</a-col>
        <a-col :span="8">
           <a-input v-model:value="dir_name" placeholder="Directory name"/>
        </a-col>
        <a-button @click="createDirectory" :disabled="!dir_name" type="primary">Create</a-button>
      </a-row>
      <a-row>
        <a-col :span="4">Remove this directory</a-col>
        <a-button danger @click="removeDirectory" >Remove</a-button>
      </a-row>
      <a-row>
        <a-col :span="4">Create new EDD file</a-col>
        <a-col :span="8">
           <a-input v-model:value="edd_name" placeholder="File name.edd"/>
        </a-col>
        <a-button @click="createEDDfile" :disabled="!edd_name" type="primary">Create</a-button>
      </a-row>
      <a-row>
        <a-col :span="4">Create new profile EDD file</a-col>
        <a-button @click="createProfileEDDfile" type="primary">Create</a-button>
      </a-row>
    </a-space>
    <a-space v-else>
      <span>No access to edit</span>
    </a-space>
  </div>
</template>

<script setup="props, { emit }">
import { ref, defineProps, defineEmits, toRefs } from "vue";
import { useKeycloak } from "../keycloak/authentication";
import { API_HOST } from "../envconfig"

const emit = defineEmits(['create_new_EDD', 'create_new_profile_EDD', 'update:id']);
const props = defineProps({
  id: {
    required: true,
  },
  writable: {
    required: true,
  }
});
// eslint-disable-next-line
const { id, writable } = toRefs(props);

const dir_name = ref("");
const edd_name = ref("");
const profile_edd_name = ref("");

const { getHeaders } = useKeycloak();

// eslint-disable-next-line
const createDirectory = async () => {
  if (dir_name.value) {
    const headers = getHeaders();
    const path = `${API_HOST}/api/admin/create_dir?id=` + encodeURIComponent(id.value) + `&directory_name=` + encodeURIComponent(dir_name.value);
    // console.log(path);
    // console.log(headers);
    const response = await fetch(path, {
      method: 'GET',
      headers: headers
    });
    // console.log("Secured API response", response);
    const body = await response.text();

    if (response.ok) {
      const msg = "Create directory: Success: " + body
      console.log(msg);
      //alert(msg);
    } else {
      const msg = "Error " + response.status + " " + response.statusText + ": " + body;
      console.error(msg);
      alert(msg);
    }
  }
}

// eslint-disable-next-line
const removeDirectory = async () => {
  if (id.value) {
    const headers = getHeaders();
    const path = `${API_HOST}/api/admin/remove_dir?directory_name=` + encodeURIComponent(id.value);
    // console.log(path);
    // console.log(headers);
    const response = await fetch(path, {
      method: 'GET',
      headers: headers
    });
    // console.log("Secured API response", response);
    const body = await response.text();

    if (response.ok) {
      const msg = "Success: " + body
      console.log(msg);
      // alert(msg);
    } else {
      const msg = "Error " + response.status + " " + response.statusText + ": " + body;
      console.error(msg);
      alert(msg);
    }
  }
}

// eslint-disable-next-line
const createEDDfile = async () => {
  const headers = getHeaders();
  const path = `${API_HOST}/api/admin/edd_create_new`;
  console.log(path);
  console.log(headers);

  // props.id is the ID of the folder where the EDD file must be created
  let id = props.id + "/" + edd_name.value;
  if (!(id.endsWith(".edd"))) {
    id = id + ".edd";
  }

  const req_params = {
    id: id,
    name: edd_name.value,
  }
  const data = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(req_params)
  }
  console.log(data);
  const response = await fetch(path, data);
  console.log("Secured API response", response);
  const text = await response.text();

  if (!(response.ok)) {
    const msg = "Error " + response.status + " " + response.statusText + ": " + text;
    console.error(msg);
    alert(msg);
  }

  // Now replace the ID with the ID of the created EDD
  emit('update:id', id);
  emit('create_new_EDD');   // Notify parent component
}

// eslint-disable-next-line
const createProfileEDDfile = () => {
  emit('create_new_profile_EDD');
}

</script>

<style>

.admin-dir {
  background: #ffffff;
  width: 100%;
  height: 100%
}

</style>